<template>
    <div>
        <div :id="'product_card_'+product.code" class='card'>
            <a class='top-content product-link'>
               <a class='top-left-container product-link'  @click.self='productClick' :href="`/${this.product.category_url}${this.product.producturl}`">
                    <DynamicImageContainer class="product-image" :image='product.main_picture' :image_on_hover='product.second_picture' :show_different_image_on_hover='false' />
                    <div class='product-info'>
                        <div class='product-heading'>{{product.product}}</div>
                        <div class="product-sku">
                            <div v-if="product.typeid != 4 && product.typeid != 8">Case Size: 6</div>
                            <div>SKU {{product.code}}</div>
                        </div>
                        <div class="price"> 
                            <div><span>£{{product.price}}</span> excl. VAT</div>
                        </div>
                        <div class='more-details-container'>
                            <DynamicImageContainer v-show='product.flag_image != ""' class="flag-image" :image='"flags/"+product.flag_image' :show_different_image_on_hover='false' />
                            <div class="text"><i class="fa-solid fa-plus"></i> More Details</div>
                        </div>
                    </div>
               </a>

                <div class="top-right-container">
                    <div class='splodge-container'>
                        <div class="product-availability-container">
                            <div class="availability-status" :class="product.availability_color">
                                <div class='status-text' v-if="product.availability_color == 'black'">AVAILABLE<br><span class="availability-days">2-3 DAYS</span></div>
                                <div class='status-text' v-if="product.availability_color == 'green'">AVAILABLE<br><span class="availability-days">NOW</span></div>
                                <div class='status-text' v-if="product.availability_color == 'red'">NOT CURRENTLY AVAILABLE</div>
                            </div>
                        </div>
                        <OnlineOnlyBadge :tooltip='product.b2b_online_only'/>
                    </div>
                    <div v-if='this.product.total_stock != 0 && product.availability_color != "red"' class="product-quantity-change-container" :class="{'product-quantity-changer':product.typeid == '4'}">
                        <QuantityChanger theme='primary_colour' v-show='product.typeid != 4' :product='product' button_text='Add Cases' unit_type='cases' @updatedCartListener="updatedCartListener" @addToCartListener="addToCartListener"/>
                        <QuantityChanger theme='green' v-show='product.typeid != 8' :product='product' :button_text="product.typeid == '4' ? 'Add' : 'Add bottles'"  @updatedCartListener="updatedCartListener" @addToCartListener="addToCartListener"/>
                    </div>
<!--                     
                    <div v-if='!product.is_customer_product' class="wishlist">
                        <AddToWishList :product='product' @removeFromWishListListener="removeFromWishList"/>
                    </div> -->
                </div>
            </a>

            
            <!-- <div v-if='product.availability_color != "red"' class='bottom-container' :class="{'out-of-stock-message-container':product.total_stock == 0}"> -->
            <div class='bottom-container' :class="{'out-of-stock-message-container':product.total_stock == 0}">
                <!-- <div v-if='this.product.total_stock != 0' class="product-quantity-change-container" :class="{'product-quantity-changer':product.typeid == '4'}">
                    <QuantityChanger theme='primary_colour' v-show='product.typeid != 4' :product='product' button_text='Add Cases' unit_type='cases' @updatedCartListener="updatedCartListener" @addToCartListener="addToCartListener"/>
                    <QuantityChanger theme='green' v-show='product.typeid != 8' :product='product' :button_text="product.typeid == '4' ? 'Add' : 'Add bottles'"  @updatedCartListener="updatedCartListener" @addToCartListener="addToCartListener"/>
                </div> -->

                <div v-if='!product.is_customer_product' class="wishlist">
                    <AddToWishList :product='product' @removeFromWishListListener="removeFromWishList"/>
                </div>
                <div class='bottom-message'>
                    {{product.b2b_online_only}}
                </div>

            </div>
        </div>

        <div :id='"page_number_"+product.page_number'></div>
    </div>
</template>

<script>
import Button from '@/ecom/components/buttons/Button.vue'
import {checkAuth, fireOmetriaBasketEvent} from "@/global/modules/functions.js";
import OutOfStockAlert from '@/ecom/components/cart/OutOfStockAlert.vue';
import NotifyWhenAvailableButton from '@/ecom/components/buttons/NotifyWhenAvailableButton.vue';
import DynamicImageContainer from "@/ecom/components/images/DynamicImageContainer.vue";
import AddToWishList from '@/ecom/components/products/single_product/details/AddToWishList.vue';
import Tooltip from '@/ecom/components/popups/Tooltip.vue';
import QuantityChanger from '@/ecom/components/products/QuantityChanger.vue';
import OnlineOnlyBadge from '@/ecom/components/products/OnlineOnlyBadge.vue';

export default {
    components:{Button, OutOfStockAlert, NotifyWhenAvailableButton, DynamicImageContainer, AddToWishList, Tooltip, QuantityChanger, OnlineOnlyBadge},
    emits: ['updatedCartListener', 'wishlistListener', 'cardClickedListener', 'addToCartListener', 'removeFromWishListListener'],
    props: ['product', 'page_builder_mode', 'total_cart_quantity'],
    data(){
        return{
            quantity: 1,
            stock: {},
            tooltip_queue: [],
        }
    },
    computed: {
        classObject() {
            return 'red'
        }
    },
    methods:{
        productClick(e){
            if(e.ctrlKey) {
                return;
            }
            else {
                e.preventDefault();
                
                if(!this.page_builder_mode){
                    this.$emit('cardClickedListener');
                    this.$router.push(`/${this.product.category_url}${this.product.producturl}`);
                }
            }
        },
        async addToCart(){
            let response = await fetch(`/api/cart/update`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify({
                   product: this.product,
                   quantity: this.quantity,
                   type: 'increment_quantity'
                }),    
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                if(!results.stock.in_stock) {
                    let out_of_stock_message = '';
                    if(results.stock.left_in_stock > 0) {
                        out_of_stock_message = 'There are only ' + results.stock.left_in_stock  + ' of this item left in stock';
                    } else if(results.stock.left_in_stock == 0){
                        out_of_stock_message = 'This item is out of stock';
                    }
                    this.tooltip_queue.push({text: out_of_stock_message});
                } else {
                    this.quantity = 1;
                    this.tooltip_queue.push({text: 'Added to bag!'});
                    this.stock = results.stock;
                    this.$emit('updatedCartListener');
                    this.$emit('addToCartListener', this.product, this.quantity);
                    fireOmetriaBasketEvent(results.cart, results.basket_id);
                }
               
            }
        },
        blurQuantity(){
            if(isNaN(this.quantity) || this.quantity == ''){
                this.quantity = 1;
            }
        },
        incrementQuantity(){
            this.quantity++;
        },
        decrementQuantity(){
            if(this.quantity > 1){
                this.quantity--;
            }
        },
        removeFromWishList(product_code) {
            this.$emit('removeFromWishListListener', product_code);
        },
        updatedCartListener(){
            this.$emit('updatedCartListener');
        },
        addToCartListener(product, quantity){
            this.$emit('addToCartListener', product, quantity);
        },
    }
}
</script>

<style lang="scss" scoped>

.card{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    border: 1px solid rgb(185, 179, 174);
    padding: 24px;
    box-sizing: border-box;
    color: var(--maj-slate);
    border-radius: 4px;
}

.top-content{
    display: flex;
    gap: 24px;
    justify-content: space-between;
    // flex-wrap: wrap;

    @media(max-width: 1500px){
        flex-wrap: wrap;
    }
}

.top-left-container{
    display: flex;
    gap: 24px;
    width: 100%;
}

.product-info{
    display: flex;
    flex-direction: column;
    gap: 15px;
    padding-left: 5px;
    padding-right: 5px;
    text-decoration: none;
    color: #212529;
}

.product-link{
    text-decoration: none;
    color: #212529;
}

.product-heading{
    font-size: 1.2rem;
    font-weight: 500;
}

.product-image{
    width: 60px;
    height: 200px;
}

.flag-image{
    width: 30px;
    height: 30px;
}

.bottom-container{
    position: relative;
    // height: 40px;
    // margin-top: 16px;
    @media(max-width: 1024px){
    //    margin-top: 10px;
    }
}

.out-of-stock-message-container{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: auto;
}

.button{
    // width: 100px;
    // @media(max-width: 1024px){
    //     width: 70px;
    // }
    // @media(max-width: 936px){
    //     width: 100px;
    // }
}
.price{
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    font-size: 0.98rem;
    font-weight: 600;
    line-height: 25px;
}

.price-slashed{
    border-bottom: 1px dashed #283533;
}

.quantity-text-box{
    width: 40px;
    height: 38px;
    text-align: center;
    border-top: solid 1px #dee2e6;
    border-left: none;
    border-right: none;
    border: 1px solid #dee2e6;
    outline: none;
}

.add-to-cart-button{
    // width: 100px;
    position: relative;
}

.quantity-container{
    display: flex;
}

.change-quantity-button{
    border: 1px solid #dee2e6;
    height: 19px;
    width: 19px; 
    cursor: pointer;
}

.no-highlight {
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
.wishlist{
    position: relative;
    min-width: 150px;
    margin-top: 4px;
}
.text{
    color: var(--primary-colour-1);
}
.successfully-added-to-bag-container{
    width: 200px;
    margin-left: -70px;
    @media(max-width: 768px){
        width: 105px;
        margin-left: -25px;
    }
}
.out-of-stock-message {
	height: 50px;
	width: 169px;
	background: #eeedac;
	border-radius: 3px;
	border-color: #eeedac;
	border: 1px solid #ffffff;
	padding: 5px 7px;
	font-size: 0.90rem;
}

.product-quantity-change-container {
	display: flex;
	// justify-content: space-between;
    flex-direction: column;
    gap: 12px;
    margin-top: 12px;
}

.product-quantity-changer {
	// justify-content: flex-end;
}

.availability-status {
	width: 80px;
	height: 80px;
	border: 1px solid #283533;
	background: #283533;
	border-radius: 50%;
	position: relative;
	font-size: 0.67rem;
	font-weight: 300;
	text-align: center;
	color: #ffffff;
    display: flex;
    align-items: center;
}

.availability-status.black {
	border: 1px solid #283533;
	background: #283533;
}

.availability-status.red {
	border: 1px solid #880D27;
	background: #880D27;
	// padding-top: 12px;
}

.availability-status.green {
	border: 1px solid #134A2C;
	background: #134A2C;
}

.availability-days {
	font-size: 0.79rem;
	font-weight: 600;
}

.status-text{
    width: 100%;
}

.top-right-container {
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: flex-end;
    // width: 100%;

    @media(max-width: 1500px){
        align-items: flex-start;
    }

	gap: 24px;
}

.product-sku {
	display: flex;
	gap: 30px;
	font-size: 0.85rem;
	font-weight: 500;
	color: var(--primary-colour-2);
}

.more-details-container{
    display: flex;
    gap: 16px;
    align-items: center;
}

.splodge-container{
    display: flex;
    gap: 12px;
}

.bottom-message{
    color: var(--maj-slate);
    font-size: 0.9rem;
    margin-top: 12px;
}

</style>